// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'thumbnails';

const Model = class Thumbnail extends BaseModel {
  static modelName = 'Thumbnail';

  static instanceDefaults() {
    return {
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
